import React, { useEffect, useState, useMemo } from 'react';
import EduCoursesTable from '../../../common/FriEdu/EduCoursesTable.jsx';
import { CollapseBlock, MainTitle, Spinner } from '../../../common/index';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../../utils/helpers/ApiClient';
import { useGetEduCoursesForPublicQuery } from '../../../../redux/services/eduCourses';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Alert } from 'antd';

export const EduCoursesPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    data: activeAndCreatedDates,
    isLoading,
    refetch,
  } = useGetEduCoursesForPublicQuery();
  const isLoggedIn = useSelector((s) => s.auth.isLoggedIn);

  useEffect(() => {
    document.title = 'FRI.edu - ' + t('Zoznam kurzov');
  }, [t]);

  // Refetch when auth state changes (e.g., user logs out or logs in)
  useEffect(() => {
    if (typeof refetch === 'function') {
      refetch();
    }
  }, [isLoggedIn, refetch]);

  // persist expanded nested rows across navigation
  const [expandedRowKeys, setExpandedRowKeys] = useState(() => {
    try {
      const saved = localStorage.getItem(
        'public-edu-courses-table-expanded-rows',
      );
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  const handleExpandedRowsChange = (newExpandedRowKeys) => {
    setExpandedRowKeys(newExpandedRowKeys);
    localStorage.setItem(
      'public-edu-courses-table-expanded-rows',
      JSON.stringify(newExpandedRowKeys),
    );
  };

  // Show the alert only if there is at least one course with at least one term
  const showAlert = useMemo(() => {
    const list = activeAndCreatedDates;
    if (!Array.isArray(list)) return false;
    return list.some((c) => {
      if (typeof c?.dates_count === 'number') return c.dates_count > 0;
      if (Array.isArray(c?.edu_course_dates))
        return c.edu_course_dates.length > 0;
      if (Array.isArray(c?.children)) return c.children.length > 0;
      if (typeof c?.has_dates === 'boolean') return c.has_dates;
      return false;
    });
  }, [activeAndCreatedDates]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <MainTitle title={t('FRI.edu')} />

      {showAlert && (
        <div style={{ marginBottom: 12 }}>
          <Alert
            type="info"
            style={{ marginBottom: '10px' }}
            showIcon={true}
            description={
              <>
                {t('Kliknutím na tlačidlo')}
                <span
                  aria-label={t('Rozbaliť riadok')}
                  style={{
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '0 6px',
                    width: 18,
                    height: 18,
                    border: '1px solid #d9d9d9',
                    borderRadius: 4,
                    background: '#fafafa',
                    color: '#0e306d',
                    userSelect: 'none',
                    fontFamily: `'Roboto Condensed'`,
                    fontWeight: 100,
                    fontSize: 16,
                    lineHeight: '18px',
                  }}
                >
                  +
                </span>
                {t('pri riadku daného kurzu zobrazíte dostupné termíny.')}
              </>
            }
          />
        </div>
      )}

      <CollapseBlock isPublic={true} title={t('Zoznam aktuálnych kurzov')}>
        <EduCoursesTable
          isPublic={true}
          courses={activeAndCreatedDates}
          onDetailClick={(record) => {
            navigate(`${routes.eduCourses}/${record.id}`);
          }}
          expandedRowKeys={expandedRowKeys}
          onExpandedRowsChange={handleExpandedRowsChange}
        />
      </CollapseBlock>
    </>
  );
};

export default EduCoursesPage;
